import { useQueryClient } from '@tanstack/react-query'
import React, { useEffect } from 'react'
import { Container } from '../../components'
import { VendorProjectAnalyticsTable } from './VendorProjectAnalyticsTable'

export const VendorProjectAnalyticsPage: React.FC = () => {
    const queryClient = useQueryClient()

    useEffect(() => {
        queryClient.invalidateQueries({
            queryKey: ['vendor-project-analytics'],
            exact: false,
        })
        queryClient.invalidateQueries({
            queryKey: ['vendor-project-analytics-all'],
            exact: false,
        })
        queryClient.invalidateQueries({
            queryKey: ['vendor-profit-trends'],
            exact: false,
        })
    }, [queryClient])

    return (
        <Container style={{ flex: 1, flexDirection: 'column', height: '100%' }}>
            <VendorProjectAnalyticsTable />
        </Container>
    )
}
